import { render, staticRenderFns } from "./ItemClass.vue?vue&type=template&id=6e4e2f38&scoped=true"
import script from "./ItemClass.vue?vue&type=script&lang=js"
export * from "./ItemClass.vue?vue&type=script&lang=js"
import style0 from "./ItemClass.vue?vue&type=style&index=0&id=6e4e2f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4e2f38",
  null
  
)

export default component.exports